import {chemicalLaboratoryId} from './chemical-lab-config';
import type {InteractiveResource, ResourceConfig} from './interactive-resources';
import {validateResourceConfig} from './resource-config';

export function resourcePresentationUrl(resource:InteractiveResource, config:ResourceConfig=resource.defaultConfig??{}) {
 // A public URL cannot carry the teacher's private experiment configuration.
 if(resource.resourceId===chemicalLaboratoryId)return '/animations/laboratoire?activity=tp5';
 const params=new URLSearchParams({resource:resource.resourceId,v:String(resource.version)});
 if(resource.parameterSchema){
  const result=validateResourceConfig(resource.resourceId,config);
  if(result.errors.length)throw new Error(result.errors.join(' · '));
  params.set('config',JSON.stringify(result.config));
 }
 return '/animations/presentation?'+params;
}
